import { render, staticRenderFns } from "./AttachFileBtn.vue?vue&type=template&id=11c14b40&scoped=true&"
import script from "./AttachFileBtn.vue?vue&type=script&lang=js&"
export * from "./AttachFileBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c14b40",
  null
  
)

export default component.exports